import { render } from "./lookupresult.vue?vue&type=template&id=5d986176"
import script from "./lookupresult.vue?vue&type=script&lang=js"
export * from "./lookupresult.vue?vue&type=script&lang=js"

import "./lookupresult.vue?vue&type=style&index=0&id=5d986176&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__